import { getCookie } from "./cookieUtils";

export const MONARCH_EXPERIMENT_COOKIE_NAME = "monarch_experiment";

export type MonarchExperiment = {
  experimentName: string;
  isControl: boolean;
};

export function getMonarchExperimentFromCookie(): MonarchExperiment | null {
  const raw = getCookie(MONARCH_EXPERIMENT_COOKIE_NAME);
  if (!raw) return null;

  try {
    const parsed = JSON.parse(decodeURIComponent(raw)) as Partial<MonarchExperiment>;
    if (!parsed?.experimentName || typeof parsed.isControl !== "boolean") return null;

    return {
      experimentName: parsed.experimentName,
      isControl: parsed.isControl,
    };
  } catch {
    return null;
  }
}

